// extracted by mini-css-extract-plugin
export default {"closeButton":"PopUpDeleteDraft_closeButton__SNi1b","rounded":"PopUpDeleteDraft_rounded__PzvBT"};